import React, { useEffect } from "react";
import MetaTagContents from "../../MetaTagContents";
import { Helmet } from "react-helmet";
import NavBar from "../landingPage/header/navbar";
import Footer from "../landingPage/footer";
import Content from "./Content";
import { Layout } from "antd";
import posthog from "posthog-js";
import { REGISTER_POSTHOG_API_KEY, POSTHOG_API_HOST } from "../../env";
import { readConsent } from "../../consentManager";

const PricingPage = () => {
  const { name, content } = MetaTagContents.SUBSCRIPTION_PLANS;

  useEffect(() => {
    const consent = readConsent();
    if (!consent?.analytics) return;

    const urlParams = new URLSearchParams(window.location.search);
    let utmSource = urlParams.get('utm_source');
    const email = urlParams.get('email') || "";

    const phInstance = posthog.init(REGISTER_POSTHOG_API_KEY, {
      api_host: POSTHOG_API_HOST,
      autocapture: false,
      name: "register",
      capture_pageview: false,
      disable_session_recording: true,
      loaded: (ph) => {
        if (utmSource) {
          ph.register({ utm_source: utmSource });
        }
      },
    });

    if (!utmSource) {
      utmSource = 'direct';
    }

    if (phInstance) {
      phInstance.capture('pricing_page_visit', {
        utm_source: utmSource,
        location: window.location.pathname,
        email: email
      });
    }
  }, []);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{MetaTagContents.SUBSCRIPTION_PLANS.title}</title>
        <link rel="canonical" href="https://all3d.ai/pricing" />
        <meta name={name} content={content} />
      </Helmet>
      <NavBar />
      <Layout>
        <Content />
      </Layout>
      <Footer />
    </>
  );
};

export default PricingPage;
